import React from "react";
import styled from "styled-components";
import logo from "../../Assets/Logo/virtuosoft-logo-2x.png";
import { useNavigate } from "react-router-dom";
import { COLORS } from "../../Constants/colors";

const FooterWrapper = styled.footer`
  background-color: ${COLORS.footerBG};
  color: ${COLORS.textSecondary};
  padding: 80px 100px 40px;

  @media (max-width: 768px) {
    padding: 60px 24px 24px;
  }
`;

const FooterContent = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 40px;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const CTA = styled.div`
  flex: 1;
  font-size: 48px;
  font-weight: 300;
  line-height: 1.3;
  display: flex;
  flex-direction: column;

  span:last-child {
    margin-top: 16px;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 12px;
    font-weight: 500;
    color: ${COLORS.secondary};

    svg {
      margin-left: 8px;
    }
  }

  @media (max-width: 768px) {
    font-size: 32px;
    line-height: 1.4;
  }
`;

const Links = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 32px;

  ul {
    list-style: none;
    padding: 0;
    margin: 0;

    li {
      font-size: 18px;
      line-height: 36px;
      cursor: pointer;
      transition: color 0.3s ease;

      &:hover {
        color: ${COLORS.secondary};
      }

      a {
        text-decoration: none;
        color: inherit;
      }
    }
  }

  @media (max-width: 768px) {
    justify-content: flex-start;
    flex-direction: column;
    gap: 24px;
  }
`;

const DividerLine = styled.div`
  height: 1px;
  background-color: #393939;
  margin: 60px 0 24px;
`;

const BottomRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 24px;

  img {
    width: 160px;
    height: auto;
    cursor: pointer;
  }

  span {
    font-size: 14px;
    color: ${COLORS.textSecondary};
  }

  @media (max-width: 768px) {
    flex-direction: column;
    text-align: center;
  }
`;

const Footer = () => {
  const navigate = useNavigate();

  const navigateToContact = () => {
    window.scrollTo(0, 0);
    navigate("/contact-us");
  };

  const handleNavigate = (path) => {
    if(path === "/") {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
    navigate(path);
  };

  return (
    <FooterWrapper>
      <FooterContent>
        <CTA>
          <span>Have A Project</span>
          <span onClick={navigateToContact}>
            {"In Mind? Let's Talk"}
            <svg
              width="84"
              height="52"
              viewBox="0 0 84 52"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="1"
                y="1"
                width="82"
                height="50"
                rx="25"
                stroke={COLORS.secondary}
                strokeWidth="2"
              />
              <path
                d="M35 26.5059H49"
                stroke={COLORS.secondary}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M42 33.5938L49 26.5114L42 19.429"
                stroke={COLORS.secondary}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>
        </CTA>

        <Links>
          <ul>
            <li onClick={() => handleNavigate("/")}>Home</li>
            <li onClick={() => handleNavigate("/ai")}>AI</li>
            <li onClick={() => handleNavigate("/fintech")}>FinTech</li>
            <li onClick={() => navigate("/#projects")}>
              {/* <a href="/#about-us">About</a> */}
              Projects
            </li>
            <li onClick={() => navigate("/#services")}>
              {/* <a href="/#services">Services</a> */}
              Services
            </li>
            <li onClick={() => navigate("/products")}>Products</li>
          </ul>
          <ul>
          <li onClick={() => navigate("/#expertise")}>Expertise</li>
          <li onClick={() => navigate("/#about-us")}>About Us</li>
            <li>
              <a
                href="https://www.linkedin.com/company/virtuosoft"
                target="_blank"
                rel="noreferrer"
              >
                LinkedIn
              </a>
            </li>
          </ul>
        </Links>
      </FooterContent>

      <DividerLine />

      <BottomRow>
        <img src={logo} alt="Virtuosoft Logo"  onClick={() => handleNavigate("/")}/>
        <span>Copyright © 2025 Virtuosoft</span>
      </BottomRow>
    </FooterWrapper>
  );
};

export default Footer;

